import http from 'src/http'

class PasswordService {
  postPassword (password) {
    return http.post('/password', {'password': password})
  }
}

export default new PasswordService()
